// extracted by mini-css-extract-plugin
export default {"Col":"Detail_Col__17IYp","Row":"Detail_Row__+WycB","Properties":"Detail_Properties__VNcT-","Box":"Detail_Box__dw7uy"};